import Controller from '@ember/controller';
import { service } from '@ember/service';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';
import { RegistrationNextSteps } from 'register-partners-js/react/components/registration-next-steps';

export default class RegistrationNextStepsController extends Controller {
  mainLayout = MainLayout;

  registrationNextSteps = RegistrationNextSteps;

  @service intl;
  @service deviceManager;
  @service networkManager;

  get isEmbeddedTemplate() {
    return this.model.registration.isEmbedded;
  }
}
